import React from "react";
import Modal from "react-bootstrap/Modal";
import XoaHopDongApi from "service/xoaHopDongApi";

class Xoa extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chovay: {},
      isActionDel: false,
    };
    this.handleEscKey = this.handleEscKey.bind(this);
  }

  componentDidMount() {
    document.addEventListener("keydown", this.handleEscKey); // Lắng nghe sự kiện nhấn phím
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleEscKey); // Xóa lắng nghe sự kiện khi component unmount
  }

  handleEscKey(event) {
    if (event.key === "Escape") {
      if (this.props.xoahopdong.showModalXoaHD) this.props.showXoaHopDong(); // Gọi hàm để đóng modal khi nhấn phím Esc
    }
  }
  componentDidUpdate() {
    let { data, kiemTraXoaHopDong, xoahopdong } = this.props;
    let { showModalXoaHD } = xoahopdong;
    let { chovay, isActionDel } = this.state;
    if (data !== chovay && showModalXoaHD) {
      kiemTraXoaHopDong({ chovayId: data.ChoVayId });
      this.setState({ chovay: data, isActionDel: false });

      XoaHopDongApi.kiemTraXoaHopDongKySo({ chovayId: data.ChoVayId }).then(
        (res) => {
          console.log("kiemTraXoaHopDongKySo", res);
          if (res?.data?.IsKySo !== undefined) {
            this.setState({ isKySo: res.data.IsKySo });
          }
        },
      );
    }
  }
  deleteHopDong = () => () => {
    let { isActionDel } = this.state;
    this.setState({ isActionDel: !isActionDel });
    let { xoaHopDong, data, getList } = this.props;
    xoaHopDong({ chovayId: data.ChoVayId }, getList);
  };
  render() {
    let props = this.props;
    let { xoahopdong, showXoaHopDong, data } = props;
    let { showModalXoaHD, isAllowDelete } = xoahopdong;
    let { isActionDel, isKySo } = this.state;
    let { Code, CustomerName } = data;
    return (
      <Modal
        show={showModalXoaHD}
        size="modal-dialog modal-dialog"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-new modal fade text-left"
      >
        <Modal.Header>
          <h4 className="modal-title" id="myModalLabel16">
            <span className="btn-icon-right">
              <i className="mdi mdi-delete"></i>
            </span>
            Xác nhận xoá
          </h4>
          <button
            type="button"
            className="close-popup-new"
            onClick={showXoaHopDong}
          >
            <i className="mdi mdi-close"></i>
          </button>
        </Modal.Header>
        <Modal.Body className="">
          <form className="form tat-toan form-horizontal">
            <div className="form-body">
              <div className="form-body">
                {isAllowDelete && !isKySo && (
                  <div className="form-group row">
                    <label
                      className="col-md-12 label-control text-left"
                      for="projectinput2"
                    >
                      Bạn có chắc chắn muốn xóa không?
                    </label>
                  </div>
                )}
                {!isAllowDelete && (
                  <div>
                    Hợp đồng <span class="home-new-blue">{Code}</span>&nbsp;của
                    khách hàng <span class="home-new-blue">{CustomerName}</span>{" "}
                    đã sinh ra phiếu thu (hoặc đã ký số). Nên bạn không thể thực
                    hiện việc xóa.&nbsp;
                    <br />
                    Muốn xóa bạn phải đi đến phiếu thu đó tại: Quản lý thu chi
                    -&gt; Thu/Chi hợp đồng
                  </div>
                )}
                {isKySo && (
                  <div>
                    Hợp đồng <span class="home-new-blue">{Code}</span>&nbsp;của
                    khách hàng <span class="home-new-blue">{CustomerName}</span>{" "}
                    đã ký số. Nên bạn không thể thực hiện việc xóa.&nbsp;
                    <br />
                  </div>
                )}
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          {isAllowDelete && isActionDel == false && (
            <button
              type="button"
              className="btn btn-new-main btn-checknew"
              onClick={this.deleteHopDong()}
            >
              <span className="btn-icon-left">
                <i className="mdi mdi-check"></i>
              </span>
              Xác nhận
            </button>
          )}

          <button
            type="button"
            className="btn btn-new-main btn-closenew"
            onClick={showXoaHopDong}
          >
            <span className="btn-icon-left">
              <i className="mdi mdi-close"></i>
            </span>
            Đóng
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}
export default Xoa;
